import { render, staticRenderFns } from "./ProjectFrame.vue?vue&type=template&id=3c8945a0&"
import script from "./ProjectFrame.vue?vue&type=script&lang=js&"
export * from "./ProjectFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports